export const tournamentTourSteps = [
  {
    target: null,
    title: 'Welcome to your tournament!',
    content: 'Let\'s walk through the key sections so you know where everything is and what to do next.',
    placement: 'center',
  },
  {
    target: '[data-tour="tournament-actions"]',
    title: 'Quick Actions',
    content: 'These links let you jump to any editing section — manage teams, edit rounds, update tournament details, and more.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="tournament-teams"]',
    title: 'Playing Teams',
    content: 'Your teams are listed here. Click "Manage Players" on any team to set up their squad — add players, assign roles, and configure the playing XI.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="tournament-rounds"]',
    title: 'Rounds & Groups',
    content: 'Rounds organize your tournament structure. Each round can have groups, and groups contain matches between your teams.',
    placement: 'top',
  },
  {
    target: '[data-tour="tournament-add-match"]',
    title: 'Create Matches',
    content: 'Click here to add rounds and schedule matches. Set the date, stadium, and choose which teams play against each other.',
    placement: 'top',
  },
  {
    target: '[data-tour="tournament-info"]',
    title: 'Basic Information',
    content: 'Review your tournament details here — dates, format, and other settings. Use "Edit tournament" from the quick actions to make changes.',
    placement: 'top',
  },
  {
    target: null,
    title: 'You\'re all set!',
    content: 'Start by managing your team squads or creating your first match. You can always retake this tour from the tournament page.',
    placement: 'center',
    actions: [
      { label: 'Manage Teams', page: 'update.teams' },
      { label: 'Create Match', page: 'update.rounds' },
    ],
  },
];
